import configs from 'configs';
import { FAILED, LOADED, LOADING, LOADING_STATUS } from 'constants/data';
import { store } from 'store';
import { openToaster } from 'store/actions';

const { API } = configs;

class Fetch {
  static GET = (path, params) => Fetch.fetch(path, { method: 'GET', ...params });

  static POST = (path, params) => Fetch.fetch(path, { method: 'POST', ...params });

  static PUT = (path, params) => Fetch.fetch(path, { method: 'PUT', ...params });

  static PATCH = (path, params) => Fetch.fetch(path, { method: 'PATCH', ...params });

  static fetch = async (path, { action, url, isFormData, body, ...params }) => {
    const { dispatch } = store;
    const API_URL = url || API;
    const loadingStatus = `${action}_${LOADING_STATUS}`;

    dispatch({
      type: loadingStatus,
      payload: LOADING,
    });

    try {
      const requestOptions = {
        ...params,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...params.headers,
        },
      };

      if (isFormData) {
        // 'multipart / form-data' should not be specified in header, so browser will add boundary
        delete requestOptions.headers['Content-Type'];
      }

      if (body) {
        requestOptions.body = isFormData ? body : JSON.stringify(body);
      }

      const res = await fetch(`${API_URL}${path}`, requestOptions);

      const response = await res.json();

      if (res.ok) {
        if (!response.result) {
          return response;
        }
        dispatch({
          type: action,
          payload: response.result,
        });

        dispatch({
          type: loadingStatus,
          payload: LOADED,
        });
      } else {
        dispatch({
          type: loadingStatus,
          payload: FAILED,
        });
        dispatch(
          openToaster({
            key:
              response.message?.key ||
              response.message ||
              response.reason ||
              response.error?.message,
            params:
              response.message?.params || response.reason || response.error?.message,
          }),
        );
      }
      return {
        result: response.result,
        error: response.message || response.reason || response.error?.message,
      };
    } catch {
      dispatch({
        type: loadingStatus,
        payload: FAILED,
      });

      return { error: 'Some Error Occurred' };
    }
  };
}

export default Fetch;
